// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"10a4cc8e","105":"e7a5baa6","157":"4caf5c3b","251":"0f1cd3aa","310":"bc6ab187","459":"fccecfc7","616":"3b28172a","653":"650d541b","771":"a131ba73","794":"b6f0789f"}[chunkId] + ".chunk.js";
};